// extracted by mini-css-extract-plugin
export var attachment = "_k9-a";
export var emailContainer = "_k9-4";
export var emailContentPaddedContainer = "_k9-b";
export var emailHeader = "_k9-6";
export var emailIframe = "_k9-3";
export var emailInfoIcon = "_k9-9";
export var emailShortenedSummary = "_k9-e";
export var infoDropdown = "_k9-0";
export var infoRowBoundedContent = "_k9-d";
export var internal = "_k9-5";
export var merchant = "_k9-8";
export var messageInputContainer = "_k9-h";
export var normal = "_k9-7";
export var replyCard = "_k9-f";
export var subtleButton = "_k9-1";
export var subtleButtonIconContainer = "_k9-2";
export var toggleViewRepliesButton = "_k9-c";
export var wrappingText = "_k9-g";